import './style.css';
const labels = { name: 'Nombre pendiente', price: 'Precio pendiente', batchNumber: 'Lote pendiente' };
export const ProductMonitoringFields = ({ fields = [] }) => <div className="product-monitoring-fields">
  {fields.filter(field => labels[field]).map(field => <span key={field}>{labels[field]}</span>)}
</div>;
